import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Modal from '@material-ui/core/Modal';
import Paper from '@material-ui/core/Paper';
import IconButton from '@material-ui/core/IconButton';
import Icon from '@material-ui/core/Icon';

const ModalStyled = styled(Modal)`
  display: flex;
  align-items: center;
  justify-content: center;
`
const PaperStyled = styled(Paper)`
  position: relative;
  outline: none;
  padding: 40px 10px 20px;
`

const IconButtonStyled = styled(IconButton)`
  position: absolute;
  right: 2px;
  top: 2px;
  padding: 8px;
`

class GenericModal extends React.Component {
  render(){
    const { children, className, onClose, open, onBackdropClick } = this.props;

    return (
      <ModalStyled open={open} onBackdropClick={onBackdropClick}>
        <PaperStyled className={className}>
          <IconButtonStyled onClick={onClose}>
            <Icon>close</Icon>
          </IconButtonStyled>
          {children}
        </PaperStyled>
      </ModalStyled>
    )
  }
}

GenericModal.propTypes = {
  header: PropTypes.string,
};

GenericModal.defaultProps = {
}

export default GenericModal;
